<style lang="scss">
@media screen and (min-width: 55rem) {
  .membershipbenefit-container {
    margin-top: 5rem;

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    .membershipbenefit {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .membershipbannercard-top {
        width: 100%;
        height: 10rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .membershipbannercard-top-subtitle {
          font-size: 1rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .membershipbannercard-top-title {
          font-size: 2rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: bold;
          color: #4b4b4b;
        }
        .membershipbannercard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .membershipopeningmethodcontent {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 80%;
        height: 10rem;
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #7f7f7f;
        font-size: 1.1rem;
        font-weight: 400;
      }
      .membershipbannercontent-list {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 80%;
        .membershipbannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .membershipbannercontent-item-title {
            font-size: 1.3125rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .membershipbannercontent-item-span {
            font-size: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 400;
            color: #0d131a;
          }

          .membershipbannercontent-item-qrcode {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
          .membershipbannercontent-item-mobile {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-2.png");
            background-size: 100% 100%;
          }
          .membershipbannercontent-item-gift {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-3.png");
            background-size: 100% 100%;
          }
        }
        .membershipbannercontent-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
      .membershipbannercontent-list-2 {
        margin-top: 5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        .membershipbannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .membershipbannercontent-item-title {
            font-size: 1.3125rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .membershipbannercontent-item-span {
            font-size: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 400;
            color: #0d131a;
          }

          .membershipbannercontent-item-qrcode {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
          .membershipbannercontent-item-mobile {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-2.png");
            background-size: 100% 100%;
          }
          .membershipbannercontent-item-gift {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membershipcard-3.png");
            background-size: 100% 100%;
          }
        }
        .membershipbannercontent-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .membershipbenefit-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    margin-top: 2rem;
    .membershipbenefit {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;
      .membershipbannercard-top {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .membershipbannercard-top-subtitle {
          font-size: 1rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .membershipbannercard-top-title {
          font-size: 2rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: bold;
          color: #4b4b4b;
        }
        .membershipbannercard-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .membershipopeningmethodcontent {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 80%;
        height: 10rem;
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #7f7f7f;
        font-size: 1.1rem;
        font-weight: 400;
      }
      .membershipbannercontent-list {
        margin-top: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 80%;
        .membershipbannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .membershipbannercontent-item-title {
            font-size: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .membershipbannercontent-item-span {
            display: none;
            // font-size: 1rem;
            // font-family: 'PingFang SC','Microsoft YaHei';
            // font-weight: 400;
            // color: #0d131a;
          }

          .membershipbannercontent-item-qrcode {
            width: 5rem;
            height: 5rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
        }
        .membershipbannercontent-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
      .membershipbannercontent-list-2 {
        margin-top: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 60%;
        .membershipbannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .membershipbannercontent-item-title {
            font-size: 1rem;
            font-family: "PingFang SC", "Microsoft YaHei";
            font-weight: 500;
            color: #333333;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }

          .membershipbannercontent-item-span {
            // font-size: 1rem;
            // font-family: 'PingFang SC','Microsoft YaHei';
            // font-weight: 400;
            // color: #0d131a;
            display: none;
          }

          .membershipbannercontent-item-qrcode {
            width: 5rem;
            height: 5rem;
            background-image: url("/media/yintai/membershipcard-1.png");
            background-size: 100% 100%;
          }
        }
        .membershipbannercontent-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>

<template>
  <div class="membershipbenefit-container">
    <div class="membershipbenefit">
      <div class="membershipbannercard-top">
        <div class="membershipbannercard-top-subtitle">INTRODUCTIONS</div>
        <div class="membershipbannercard-top-title">专属权益</div>
        <div class="membershipbannercard-top-line"></div>
      </div>
      <div class="membershipbannercontent-list">
        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/1.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">消费折扣</div>
          <div class="membershipbannercontent-item-span">消费享折上9折</div>
          <div class="membershipbannercontent-item-span">
            （个别品类折上98折）
          </div>
        </div>
        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/2.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">会员洗衣</div>
          <div class="membershipbannercontent-item-span">
            专享5折
          </div>
        </div>
        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/3.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">会员洗车</div>
          <div class="membershipbannercontent-item-span">
            专享5折
          </div>
        </div>
      </div>
      <div class="membershipbannercontent-list">
        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/6.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">365小金库</div>
          <div class="membershipbannercontent-item-span">
            消费返金币，金币兑好物
          </div>
        </div>
        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/5.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">无忧退</div>
          <div class="membershipbannercontent-item-span">
            退货免运费
          </div>
        </div>

        <div class="membershipbannercontent-list-item">
          <div
            class="membershipbannercontent-item-qrcode"
            style="
              background-image: url('/media/yintai/membershipintroduction/7.png');
            "
          ></div>
          <div class="membershipbannercontent-item-title">停车优惠</div>
          <div class="membershipbannercontent-item-span">专享9折</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "membershipbenefit",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
